import signedFetch from '../../../apiCalls/util/signedFetch.js';

export default function* invoiceReportApi(fromDate, toDate) {
  return yield signedFetch(
    'invoiceReport',
    `${__API_BASE__}/entitlements?fromDate=${fromDate}&toDate=${toDate}`,
    'GET'
  );
}
